import React from 'react'
import { Row, Col} from 'antd'
import IconTotalCost from '../../../assets/img/icon/icon-total-cost.png'
import './card-forecast.scss'

export default ({forecast}) => (
    <div className="forecast-container">
        <Row type="flex" >
            <Col span={24}>
                <h2>Forecast</h2>
            </Col>
        </Row>
        <Row type="flex" align="middle">
            <Col span={20}>
                <h1>{Intl.NumberFormat('en-IN', { style: 'currency', currency: 'USD', currencyDisplay: 'symbol' }).format(forecast)}</h1>
            </Col>
            <Col span={4}>
                <img src={IconTotalCost} alt='' className="icon" />
            </Col>
        </Row>
        <Row type="flex" gutter={10} align="middle">
            <Col span={12}>
                <div className="color-line"></div>
            </Col>
            <Col span={12}>
                {/* <h3>Till August 2017</h3> */}
            </Col>
        </Row>

    </div>
)